<div class="row megabanner">
  <div class="col-12 col-sm-12 col-md-6 col-lg-6">
    <span class="mega-type-banner">Pool Type</span>
    <ng-container *ngIf="showSFFixedMega">
      <h2 class="mega-type-header-banner">Single Family Fixed Rate</h2>
    </ng-container>
    <ng-container *ngIf="showSFARMMega">
      <h2 class="mega-type-header-banner">Single Family ARM</h2>
    </ng-container>
    <ng-container *ngIf="showMFFixedMega">
      <h2 class="mega-type-header-banner">Multi Family Fixed Rate</h2>
    </ng-container>
    <ng-container *ngIf="showMFARMMega">
      <h2 class="mega-type-header-banner">Multi Family ARM</h2>
    </ng-container>
  </div>
  <div class="col-12 col-sm-12 col-md-6 col-lg-6 text-end">
    <div class="col-6 col-sm-6 col-md-6 col-lg-6 line">
      <span class="mega-type-banner">Committed this Month</span>
      <ng-container *ngIf="showSFFixedMega">
        <h2 class="mega-type-header-banner">
          {{ totalCommittedCurrentMonthSFFIXMEGA | currency: 'USD' : 'symbol' : '1.2-2' }}
        </h2>
      </ng-container>
      <ng-container *ngIf="showSFARMMega">
        <h2 class="mega-type-header-banner">
          {{ totalCommittedCurrentMonthSFARMMEGA | currency: 'USD' : 'symbol' : '1.2-2' }}
        </h2>
      </ng-container>
      <ng-container *ngIf="showMFFixedMega">
        <h2 class="mega-type-header-banner">
          {{ totalCommittedCurrentMonthMFFIXMEGA | currency: 'USD' : 'symbol' : '1.2-2' }}
        </h2>
      </ng-container>
      <ng-container *ngIf="showMFARMMega">
        <h2 class="mega-type-header-banner">
          {{ totalCommittedCurrentMonthMFARMMEGA | currency: 'USD' : 'symbol' : '1.2-2' }}
        </h2>
      </ng-container>
    </div>
    <div class="col-6 col-sm-6 col-md-6 col-lg-6 text-end">
      <span class="mega-type-banner">Total Committed Volume</span>
      <ng-container *ngIf="showSFFixedMega">
        <h2 class="mega-type-header-banner">
          {{ totalCommittedVolumeSFFIXMEGA | currency: 'USD' : 'symbol' : '1.2-2' }}
        </h2>
      </ng-container>
      <ng-container *ngIf="showSFARMMega">
        <h2 class="mega-type-header-banner">
          {{ totalCommittedVolumeSFARMMEGA | currency: 'USD' : 'symbol' : '1.2-2' }}
        </h2>
      </ng-container>
      <ng-container *ngIf="showMFFixedMega">
        <h2 class="mega-type-header-banner">
          {{ totalCommittedVolumeMFFIXMEGA | currency: 'USD' : 'symbol' : '1.2-2' }}
        </h2>
      </ng-container>
      <ng-container *ngIf="showMFARMMega">
        <h2 class="mega-type-header-banner">
          {{ totalCommittedVolumeMFARMMEGA | currency: 'USD' : 'symbol' : '1.2-2' }}
        </h2>
      </ng-container>
    </div>
  </div>
</div>
<div class="fm-cdx-table">
  <ng-container *ngIf="showSFFixedMega && singleFamilyFixedMega === 'SFFIXMEGA'">
    <table class="fm-cdx-table__static">
      <thead>
        <tr class="th_row">
          <th class="th_column th_icon">EDIT</th>
          <th
            class="th_column th_sortable-column sortable-column"
            (click)="sortByGridByColumnName('poolNumber')"
          >
            <span>POOL #/cusip</span>
            <a class="column-name">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'poolNumber'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'poolNumber'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th class="th_column">PREFIX</th>
          <th class="th_column">COUPON</th>
          <th
            class="th_column th_column--is-numeric th_sortable-column sortable-column"
            (click)="sortByGridByColumnName('tradeAmount')"
          >
            <span>deal amount/fee</span>
            <a class="column-name">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'tradeAmount'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'tradeAmount'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th
            class="th_column th_sortable-column sortable-column"
            (click)="sortByGridByColumnName('tradeSettlementDate')"
          >
            <span>settlement</span>
            <a class="column-name">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'tradeSettlementDate'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'tradeSettlementDate'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th class="th_column">
            <span>COLLATERAL STATUS</span>
            <span class="committed-listing-action">ACTIONS</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="td_row commit-mega-table-header"
          *ngFor="
            let committedMega of SFFixedMegaList | paginate: config;
            let i = index;
            trackBy: trackByIdentity
          "
        >
          <ng-container
            *ngIf="!hasCreateOrEditMegaAccessFlag || committedMega.isEditable !== 'true'"
          >
            <td class="td_cell td_icon">
              <span class="fa fa-pencil-square-o fa-lg edit_icon not-editable in-active-icon">
              </span>
            </td>
          </ng-container>
          <ng-container
            *ngIf="hasCreateOrEditMegaAccessFlag && committedMega.isEditable === 'true'"
          >
            <td class="td_cell td_icon">
              <span
                class="fa fa-pencil-square-o fa-lg edit_icon edit"
                (click)="goToEnterMega(committedMega)"
              ></span>
            </td>
          </ng-container>
          <td class="td_cell commit-mega-pool-number" id="SFFIXMega-pool-number">
            <span class="collateral-big">{{ committedMega?.poolNumber }}</span
            ><br />
            {{ committedMega?.cusip }}
          </td>
          <td class="td_cell" id="SFFIXMega-commit-mega-prefix">
            <span class="collateral-big">{{ committedMega?.prefixCode }}</span>
          </td>
          <td class="td_cell" id="SFFIXMega-commit-mega-coupon">
            <span class="collateral-big">{{ committedMega?.sfFixedCoupon }}</span>
          </td>
          <td class="td_cell td_cell--is-numeric" id="SFFIXMega-deal-amount-fee">
            <span class="collateral-big">{{
              committedMega?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
            }}</span
            ><br />Fee:
            <ng-container *ngIf="committedMega.feeDollars != null">
              <ng-container *ngIf="needsDisclaimer(committedMega); else noDisclaimer">
                <span class="fee-warning-red">
                  {{ committedMega?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}*
                </span>
              </ng-container>
              <ng-template #noDisclaimer>
                {{ committedMega?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
              </ng-template>
            </ng-container>
            <ng-container *ngIf="committedMega.feeTicks != null">
              <ng-container *ngIf="needsDisclaimer(committedMega); else noDisclaimer">
                <span class="fee-warning-red"> {{ committedMega?.feeTicks }}/32* </span>
              </ng-container>
              <ng-template #noDisclaimer> {{ committedMega?.feeTicks }}/32 </ng-template>
            </ng-container>
            <ng-container
              *ngIf="committedMega.feeTicks === null && committedMega.feeDollars === null"
            >
              {{ 0 | currency: 'USD' : 'symbol' : '1.0' }}
            </ng-container>
          </td>
          <td class="td_cell" id="SFFIXMEGA-commit-mega-settlementDate">
            <span
              class="collateral-big"
              [ngClass]="{
                'overdue-red':
                  committedMega?.status === 'OVERDUE' || committedMega?.status === 'DUEWARNING',
              }"
              >{{ committedMega?.tradeSettlementDate | date: 'MM/dd/yyyy' }}</span
            ><br />
            Commit: {{ committedMega?.committedDate | date: 'MM/dd/yyyy' }}
          </td>
          <td class="td_cell">
            <ng-container *ngIf="committedMega?.status === 'ALLOCATION_PENDING'">
              <span class="allocated allocation-pending">ALLOCATION PENDING</span>
              <span class="replace float-end" *ngIf="LDshowUpload">
                <i
                  class="fa fa-info-circle tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  title="{{ committedMega?.statusInfo }}"
                ></i>
                Info</span
              >
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'ALLOCATED'">
              <div class="collateral-status-container">
                <span class="allocated allocated-green collateral-sub-column"
                  >ALLOCATED <i class="fa fa-check-circle icon-disable allocated-green"></i
                ></span>
                <div class="collateral-sub-column">
                  <span class="replace float-end" *ngIf="LDshowUpload">
                    <i
                      class="fa fa-download download-template-icon"
                      (click)="downloadCollateralPool(committedMega)"
                    ></i>
                    <a
                      class="download-pool-info-template icon-pos"
                      (click)="downloadCollateralPool(committedMega)"
                      >Download</a
                    >
                  </span>
                  <br />
                  <ng-container
                    *ngIf="
                      LDDeallocateButton && settlementDateCheck(committedMega?.tradeSettlementDate)
                    "
                  >
                    <span>
                      <i class="fa fa-solid fa-unlock deallocation-btn"></i>
                      <a
                        class="deallocation-btn icon-pos"
                        (click)="openDeallocateModal(committedMega)"
                        >Deallocate</a
                      >
                    </span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      LDDeallocateButton && !settlementDateCheck(committedMega?.tradeSettlementDate)
                    "
                  >
                    <span
                      class="tooltip-error"
                      data-bs-toggle="tooltip"
                      data-bs-html="true"
                      title="{{ disabledDeallocateText }}"
                    >
                      <i class="fa fa-solid fa-unlock icon-disable"></i>
                      <a class="deallocation-disabled icon-pos">Deallocate</a>
                    </span>
                  </ng-container>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'OVERDUE'">
              <span class="overdue">OVERDUE </span> &nbsp; &nbsp;
              <span class="replace float-end" *ngIf="LDshowUpload">
                <i
                  class="fa fa-info-circle tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  title="{{ committedMega?.statusInfo }}"
                ></i>
                Info</span
              ><br />
              <span class="overdue-red" id="SFFIXMEGA-commit-mega-statusDate-overdue">{{
                committedMega?.statusDate | date: 'MM/dd/yyyy'
              }}</span>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'DUE'">
              <div class="row">
                <div class="col-lg-6">
                  <span class="allocated">DUE </span><br />
                  <span id="SFFIXMEGA-commit-mega-statusDate-due">{{
                    committedMega?.statusDate | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
                <div class="col-lg-6" *ngIf="LDshowUpload">
                  <button
                    class="button fm-primary-button float-end upload"
                    (click)="routeToPoolInfo()"
                    [disabled]="!hasCollateralUploadAccessFlag"
                    *ngIf="LDUploadPoolInfoFlag"
                  >
                    UPLOAD
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'DUEWARNING'">
              <div class="row">
                <div class="col-lg-6">
                  <span class="allocated overdue-red">DUE </span><br />
                  <span id="SFFIXMEGA-commit-mega-statusDate-due" class="overdue-red">{{
                    committedMega?.statusDate | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
                <div class="col-lg-6" *ngIf="LDshowUpload">
                  <button
                    class="button fm-primary-button float-end upload"
                    (click)="routeToPoolInfo()"
                    [disabled]="!hasCollateralUploadAccessFlag"
                    *ngIf="LDUploadPoolInfoFlag"
                  >
                    UPLOAD
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'FAILED'">
              <div class="row">
                <div class="col-lg-6">
                  <span class="allocated commit-mega-failed overdue-red">FAILED </span><br />
                  <span id="SFFIXMEGA-commit-mega-statusDate-failed" class="overdue-red">{{
                    committedMega?.statusDate | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
                <div class="col-lg-6" *ngIf="LDshowUpload">
                  <button
                    class="button fm-primary-button float-end upload"
                    (click)="routeToPoolInfo()"
                    [disabled]="!hasCollateralUploadAccessFlag"
                    *ngIf="LDUploadPoolInfoFlag"
                  >
                    UPLOAD
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'INREVIEW'">
              <span class="in-review">IN REVIEW</span>
              <span class="replace float-end" *ngIf="LDshowUpload">
                <i
                  class="fa fa-info-circle tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  title="{{ committedMega?.statusInfo }}"
                ></i>
                Info</span
              >
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'VALIDATING'">
              <span class="in-review" id="SFFIXMEGA-mega-commit-validating">VALIDATING</span>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
  <ng-container *ngIf="showSFARMMega && singleFamilyARMMega === 'SFARMMEGA'">
    <table class="fm-cdx-table__static">
      <thead>
        <tr class="th_row">
          <th class="th_column th_icon">EDIT</th>
          <th
            class="th_column th_sortable-column sortable-column"
            (click)="sortByGridByColumnName('poolNumber')"
          >
            <span>POOL #/cusip</span>
            <a class="column-name">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'poolNumber'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'poolNumber'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th class="th_column">PREFIX</th>
          <th class="th_column" id="SFARMMEGA-subtype-column">SUB TYPE</th>
          <th
            class="th_column th_column--is-numeric th_sortable-column sortable-column"
            (click)="sortByGridByColumnName('tradeAmount')"
          >
            <span>DEAL AMOUNT/FEE</span>
            <a class="column-name">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'tradeAmount'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'tradeAmount'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th
            class="th_column th_sortable-column sortable-column"
            (click)="sortByGridByColumnName('tradeSettlementDate')"
          >
            <span>settlement</span>
            <a class="column-name">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'tradeSettlementDate'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'tradeSettlementDate'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th class="th_column">
            <span>COLLATERAL STATUS</span> <span class="committed-listing-action">ACTIONS</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="td_row commit-mega-table-header"
          *ngFor="
            let committedMega of SFARMMegaList | paginate: config;
            let i = index;
            trackBy: trackByIdentity
          "
        >
          <ng-container
            *ngIf="!hasCreateOrEditMegaAccessFlag || committedMega.isEditable !== 'true'"
          >
            <td class="td_cell td_icon">
              <span class="fa fa-pencil-square-o fa-lg edit_icon not-editable in-active-icon">
              </span>
            </td>
          </ng-container>
          <ng-container
            *ngIf="hasCreateOrEditMegaAccessFlag && committedMega.isEditable === 'true'"
          >
            <td class="td_cell td_icon">
              <span
                class="fa fa-pencil-square-o fa-lg edit_icon edit"
                (click)="goToEnterMega(committedMega)"
              ></span>
            </td>
          </ng-container>
          <td class="td_cell commit-mega-pool-number" id="SFARMMEGA-pool-number">
            <span class="collateral-big">{{ committedMega?.poolNumber }}</span
            ><br />
            {{ committedMega?.cusip }}
          </td>
          <td class="td_cell" id="SFARMMEGA-commit-mega-prefix">
            <span class="collateral-big">{{ committedMega?.prefixCode }}</span>
          </td>
          <td class="td_cell uppercase-text" id="SFARMMEGA-commit-mega-subtype">
            <span class="collateral-big">{{ committedMega?.sfARMSubType }}</span>
          </td>
          <td class="td_cell td_cell--is-numeric" id="SFARMMEGA-deal-amount-fee">
            <span class="collateral-big">{{
              committedMega?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
            }}</span
            ><br />
            Fee:
            <ng-container *ngIf="committedMega.feeDollars != null">
              {{ committedMega?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
            </ng-container>
            <ng-container *ngIf="committedMega.feeTicks != null">
              {{ committedMega?.feeTicks }}/32
            </ng-container>
            <ng-container
              *ngIf="committedMega.feeTicks === null && committedMega.feeDollars === null"
            >
              0 | currency:'USD':'symbol':'1.0'
            </ng-container>
          </td>
          <td class="td_cell" id="SFARMMEGA-commit-mega-settlementDate">
            <span
              class="collateral-big"
              [ngClass]="{
                'overdue-red':
                  committedMega?.status === 'OVERDUE' || committedMega?.status === 'DUEWARNING',
              }"
              >{{ committedMega?.tradeSettlementDate | date: 'MM/dd/yyyy' }}</span
            ><br />
            Commit: {{ committedMega?.committedDate | date: 'MM/dd/yyyy' }}
          </td>
          <td class="td_cell">
            <ng-container *ngIf="committedMega?.status === 'ALLOCATION_PENDING'">
              <span class="allocated allocation-pending">ALLOCATION PENDING</span>
              <span class="replace float-end" *ngIf="LDshowUpload">
                <i
                  class="fa fa-info-circle tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  title="{{ committedMega?.statusInfo }}"
                ></i>
                Info</span
              >
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'ALLOCATED'">
              <div class="collateral-status-container">
                <span class="allocated allocated-green collateral-sub-column"
                  >ALLOCATED <i class="fa fa-check-circle icon-disable allocated-green"></i
                ></span>
                <div class="collateral-sub-column">
                  <span class="replace float-end" *ngIf="LDshowUpload">
                    <i
                      class="fa fa-download download-template-icon"
                      (click)="downloadCollateralPool(committedMega)"
                    ></i>
                    <a
                      class="download-pool-info-template icon-pos"
                      (click)="downloadCollateralPool(committedMega)"
                      >Download</a
                    >
                  </span>
                  <br />
                  <ng-container
                    *ngIf="
                      LDDeallocateButton && settlementDateCheck(committedMega?.tradeSettlementDate)
                    "
                  >
                    <span>
                      <i class="fa fa-solid fa-unlock deallocation-btn"></i>
                      <a
                        class="deallocation-btn icon-pos"
                        (click)="openDeallocateModal(committedMega)"
                        >Deallocate</a
                      >
                    </span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      LDDeallocateButton && !settlementDateCheck(committedMega?.tradeSettlementDate)
                    "
                  >
                    <span
                      class="tooltip-error"
                      data-bs-toggle="tooltip"
                      data-bs-html="true"
                      title="{{ disabledDeallocateText }}"
                    >
                      <i class="fa fa-solid fa-unlock icon-disable"></i>
                      <a class="deallocation-disabled icon-pos">Deallocate</a>
                    </span>
                  </ng-container>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'OVERDUE'">
              <span class="overdue">OVERDUE </span> &nbsp; &nbsp;
              <span class="replace float-end" *ngIf="LDshowUpload">
                <i
                  class="fa fa-info-circle tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  title="{{ committedMega?.statusInfo }}"
                ></i>
                Info</span
              ><br />
              <span class="overdue-red">{{ committedMega?.statusDate | date: 'MM/dd/yyyy' }}</span>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'DUE'">
              <div class="row">
                <div class="col-lg-6">
                  <span class="allocated">DUE </span><br />
                  <span id="SFARMMEGA-commit-mega-statusDate-due">{{
                    committedMega?.statusDate | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
                <div class="col-lg-6" *ngIf="LDshowUpload">
                  <button
                    class="button fm-primary-button float-end upload"
                    (click)="routeToPoolInfo()"
                    [disabled]="!hasCollateralUploadAccessFlag"
                    *ngIf="LDUploadPoolInfoFlag"
                  >
                    UPLOAD
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'DUEWARNING'">
              <div class="row">
                <div class="col-lg-6">
                  <span class="allocated overdue-red">DUE </span><br />
                  <span id="SFARMMEGA-commit-mega-statusDate-due" class="overdue-red">{{
                    committedMega?.statusDate | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
                <div class="col-lg-6" *ngIf="LDshowUpload">
                  <button
                    class="button fm-primary-button float-end upload"
                    (click)="routeToPoolInfo()"
                    [disabled]="!hasCollateralUploadAccessFlag"
                    *ngIf="LDUploadPoolInfoFlag"
                  >
                    UPLOAD
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'FAILED'">
              <div class="row">
                <div class="col-lg-6">
                  <span class="allocated overdue-red">FAILED </span><br />
                  <span class="overdue-red">{{
                    committedMega?.statusDate | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
                <div class="col-lg-6" *ngIf="LDshowUpload">
                  <button
                    class="button fm-primary-button float-end upload"
                    (click)="routeToPoolInfo()"
                    [disabled]="!hasCollateralUploadAccessFlag"
                    *ngIf="LDUploadPoolInfoFlag"
                  >
                    UPLOAD
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'INREVIEW'">
              <span class="in-review">IN REVIEW</span>
              <span class="replace float-end" *ngIf="LDshowUpload">
                <i
                  class="fa fa-info-circle tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  title="{{ committedMega?.statusInfo }}"
                ></i>
                Info</span
              >
              <!--&nbsp; &nbsp; <span class="in-review-cyan float-end"><i class="fa fa-refresh"></i> Replace</span>--><br />
              {{ committedMega?.statusDate | date: 'MM/dd/yyyy' }}
              <!--&nbsp; &nbsp; <span class="replace float-end"><i class="fa fa-times-circle"></i> Remove</span>-->
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'VALIDATING'">
              <span class="in-review">VALIDATING</span>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
  <ng-container *ngIf="showMFFixedMega && multiFamilyFixedMega === 'MFFIXMEGA'">
    <table class="fm-cdx-table__static">
      <thead>
        <tr class="th_row">
          <th class="th_column th_icon">EDIT</th>
          <th
            class="th_column th_sortable-column sortable-column"
            (click)="sortByGridByColumnName('poolNumber')"
          >
            <span>POOL #/cusip</span>
            <a class="column-name">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'poolNumber'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'poolNumber'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th class="th_column">PREFIX</th>
          <th class="th_column" id="MFFIXMEGA-HiLowCoupon-column">HI/LOW COUPON</th>
          <th
            class="th_column th_column--is-numeric th_sortable-column sortable-column"
            (click)="sortByGridByColumnName('tradeAmount')"
          >
            <span>deal amount/fee</span>
            <a class="column-name">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'tradeAmount'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'tradeAmount'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th
            class="th_column th_sortable-column sortable-column"
            (click)="sortByGridByColumnName('tradeSettlementDate')"
          >
            <span>settlement</span>
            <a class="column-name">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'tradeSettlementDate'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'tradeSettlementDate'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th class="th_column">
            <span>COLLATERAL STATUS</span> <span class="committed-listing-action">ACTIONS</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="td_row commit-mega-table-header"
          *ngFor="
            let committedMega of MFFixedMegaList | paginate: config;
            let i = index;
            trackBy: trackByIdentity
          "
        >
          <ng-container
            *ngIf="!hasCreateOrEditMegaAccessFlag || committedMega.isEditable !== 'true'"
          >
            <td class="td_cell td_icon">
              <span class="fa fa-pencil-square-o fa-lg edit_icon not-editable in-active-icon">
              </span>
            </td>
          </ng-container>
          <ng-container
            *ngIf="hasCreateOrEditMegaAccessFlag && committedMega.isEditable === 'true'"
          >
            <td class="td_cell td_icon">
              <span
                class="fa fa-pencil-square-o fa-lg edit_icon edit"
                (click)="goToEnterMega(committedMega)"
              ></span>
            </td>
          </ng-container>
          <td class="td_cell commit-mega-pool-number" id="MFFIXMEGA-pool-number">
            <span class="collateral-big">{{ committedMega?.poolNumber }}</span
            ><br />
            {{ committedMega?.cusip }}
          </td>
          <td class="td_cell">
            <span class="collateral-big" id="MFFIXMEGA-commit-mega-prefix">{{
              committedMega?.prefixCode
            }}</span>
          </td>
          <td class="td_cell">
            <span class="collateral-big" id="MFFIXMEGA-commit-mega-HiLowCoupon"
              >{{ committedMega?.mfHighCoupon }}/{{ committedMega?.mfLowCoupon }}</span
            >
          </td>
          <td class="td_cell td_cell--is-numeric" id="MFFIXMEGA-deal-amount-fee">
            <span class="collateral-big">{{
              committedMega?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
            }}</span
            ><br />Fee:
            <ng-container *ngIf="committedMega.feeDollars != null">
              {{ committedMega?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
            </ng-container>
            <ng-container *ngIf="committedMega.feeTicks != null">
              {{ committedMega?.feeTicks }}/32
            </ng-container>
            <ng-container
              *ngIf="committedMega.feeTicks === null && committedMega.feeDollars === null"
            >
              {{ 0 | currency: 'USD' : 'symbol' : '1.0' }}
            </ng-container>
          </td>
          <td class="td_cell" id="MFFIXMEGA-commit-mega-settlementDate">
            <span
              class="collateral-big"
              [ngClass]="{
                'overdue-red':
                  committedMega?.status === 'OVERDUE' || committedMega?.status === 'DUEWARNING',
              }"
              >{{ committedMega?.tradeSettlementDate | date: 'MM/dd/yyyy' }}</span
            ><br />
            Commit: {{ committedMega?.committedDate | date: 'MM/dd/yyyy' }}
          </td>
          <td class="td_cell">
            <ng-container *ngIf="committedMega?.status === 'ALLOCATION_PENDING'">
              <span class="allocated allocation-pending">ALLOCATION PENDING</span>
              <span class="replace float-end" *ngIf="LDshowUpload">
                <i
                  class="fa fa-info-circle tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  title="{{ committedMega?.statusInfo }}"
                ></i>
                Info</span
              >
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'ALLOCATED'">
              <div class="collateral-status-container">
                <span class="allocated allocated-green collateral-sub-column"
                  >ALLOCATED <i class="fa fa-check-circle icon-disable allocated-green"></i
                ></span>
                <div class="collateral-sub-column">
                  <span class="replace float-end" *ngIf="LDshowUpload">
                    <i
                      class="fa fa-download download-template-icon"
                      (click)="downloadCollateralPool(committedMega)"
                    ></i>
                    <a
                      class="download-pool-info-template icon-pos"
                      (click)="downloadCollateralPool(committedMega)"
                      >Download</a
                    >
                  </span>
                  <br />
                  <ng-container
                    *ngIf="
                      LDDeallocateButton && settlementDateCheck(committedMega?.tradeSettlementDate)
                    "
                  >
                    <span>
                      <i class="fa fa-solid fa-unlock deallocation-btn"></i>
                      <a
                        class="deallocation-btn icon-pos"
                        (click)="openDeallocateModal(committedMega)"
                        >Deallocate</a
                      >
                    </span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      LDDeallocateButton && !settlementDateCheck(committedMega?.tradeSettlementDate)
                    "
                  >
                    <span
                      class="tooltip-error"
                      data-bs-toggle="tooltip"
                      data-bs-html="true"
                      title="{{ disabledDeallocateText }}"
                    >
                      <i class="fa fa-solid fa-unlock icon-disable"></i>
                      <a class="deallocation-disabled icon-pos">Deallocate</a>
                    </span>
                  </ng-container>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'OVERDUE'">
              <span class="overdue">OVERDUE </span> &nbsp; &nbsp;
              <span class="replace float-end" *ngIf="LDshowUpload">
                <i
                  class="fa fa-info-circle tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  title="{{ committedMega?.statusInfo }}"
                ></i>
                Info</span
              ><br />
              <span class="overdue-red">{{ committedMega?.statusDate | date: 'MM/dd/yyyy' }}</span>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'DUE'">
              <div class="row">
                <div class="col-lg-6">
                  <span class="allocated">DUE </span><br />
                  <span id="MFFIXMEGA-commit-mega-statusDate-due">{{
                    committedMega?.statusDate | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
                <div class="col-lg-6" *ngIf="LDshowUpload">
                  <button
                    class="button fm-primary-button float-end upload"
                    (click)="routeToPoolInfo()"
                    [disabled]="!hasCollateralUploadAccessFlag"
                    *ngIf="LDUploadPoolInfoFlag"
                  >
                    UPLOAD
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'DUEWARNING'">
              <div class="row">
                <div class="col-lg-6">
                  <span class="allocated overdue-red">DUE </span><br />
                  <span class="overdue-red" id="MFFIXMEGA-commit-mega-statusDate-due">{{
                    committedMega?.statusDate | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
                <div class="col-lg-6" *ngIf="LDshowUpload">
                  <button
                    class="button fm-primary-button float-end upload"
                    (click)="routeToPoolInfo()"
                    [disabled]="!hasCollateralUploadAccessFlag"
                    *ngIf="LDUploadPoolInfoFlag"
                  >
                    UPLOAD
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'FAILED'">
              <div class="row">
                <div class="col-lg-6">
                  <span class="allocated overdue-red">FAILED </span><br />
                  <span class="overdue-red">{{
                    committedMega?.statusDate | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
                <div class="col-lg-6" *ngIf="LDshowUpload">
                  <button
                    class="button fm-primary-button float-end upload"
                    (click)="routeToPoolInfo()"
                    [disabled]="!hasCollateralUploadAccessFlag"
                    *ngIf="LDUploadPoolInfoFlag"
                  >
                    UPLOAD
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'INREVIEW'">
              <span class="in-review">IN REVIEW</span>
              <span class="replace float-end" *ngIf="LDshowUpload">
                <i
                  class="fa fa-info-circle tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  title="{{ committedMega?.statusInfo }}"
                ></i>
                Info</span
              >
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'VALIDATING'">
              <span class="in-review">VALIDATING</span>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>

  <ng-container *ngIf="showMFARMMega && multiFamilyARMMega === 'MFARMMEGA'">
    <table class="fm-cdx-table__static">
      <thead>
        <tr class="th_row">
          <th class="th_column th_icon">EDIT</th>
          <th
            class="th_column th_sortable-column sortable-column"
            (click)="sortByGridByColumnName('poolNumber')"
          >
            <span>POOL #/cusip</span>
            <a class="column-name">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'poolNumber'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'poolNumber'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th class="th_column">PREFIX</th>
          <th class="th_column" id="MFARMMEGA-subtype-column">SUB TYPE</th>
          <th
            class="th_column th_column--is-numeric th_sortable-column sortable-column"
            (click)="sortByGridByColumnName('tradeAmount')"
          >
            <span>Deal Amount/Fee</span>
            <a class="column-name">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'tradeAmount'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'tradeAmount'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th
            class="th_column th_sortable-column sortable-column"
            (click)="sortByGridByColumnName('tradeSettlementDate')"
          >
            <span>settlement</span>
            <a class="column-name">
              <i
                class="sorting-icon-down fa fa-caret-down {{
                  presentSortedColumn === 'tradeSettlementDate'
                    ? presentSortedColumnIsAscending
                      ? ''
                      : 'in-active-icon'
                    : 'in-active-icon'
                }}"
              ></i>
              <i
                class="sorting-icon-up fa fa-caret-up {{
                  presentSortedColumn === 'tradeSettlementDate'
                    ? presentSortedColumnIsAscending
                      ? 'in-active-icon'
                      : ''
                    : 'in-active-icon'
                }}"
              ></i>
            </a>
          </th>
          <th class="th_column">
            <span>COLLATERAL STATUS</span> <span class="committed-listing-action">ACTIONS</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          class="td_row commit-mega-table-header"
          *ngFor="
            let committedMega of MFARMMegaList | paginate: config;
            let i = index;
            trackBy: trackByIdentity
          "
        >
          <ng-container
            *ngIf="!hasCreateOrEditMegaAccessFlag || committedMega.isEditable !== 'true'"
          >
            <td class="td_cell td_icon">
              <span class="fa fa-pencil-square-o fa-lg edit_icon not-editable in-active-icon">
              </span>
            </td>
          </ng-container>
          <ng-container
            *ngIf="hasCreateOrEditMegaAccessFlag && committedMega.isEditable === 'true'"
          >
            <td class="td_cell td_icon">
              <span
                class="fa fa-pencil-square-o fa-lg edit_icon edit"
                (click)="goToEnterMega(committedMega)"
              ></span>
            </td>
          </ng-container>
          <td class="td_cell commit-mega-pool-number" id="MFARMMEGA-pool-number">
            <span class="collateral-big">{{ committedMega?.poolNumber }}</span
            ><br />
            {{ committedMega?.cusip }}
          </td>
          <td class="td_cell">
            <span class="collateral-big" id="MFARMMEGA-commit-mega-prefix">{{
              committedMega?.prefixCode
            }}</span>
          </td>
          <td class="td_cell uppercase-text" id="MFARMMEGA-commit-mega-subtype">
            <span class="collateral-big">{{ committedMega?.sfARMSubType }}</span>
          </td>
          <td class="td_cell td_cell--is-numeric" id="MFARMMEGA-deal-amount-fee">
            <span class="collateral-big">{{
              committedMega?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
            }}</span
            ><br />
            Fee:
            <ng-container *ngIf="committedMega.feeDollars != null">
              {{ committedMega?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
            </ng-container>
            <ng-container *ngIf="committedMega.feeTicks != null">
              {{ committedMega?.feeTicks }}/32
            </ng-container>
            <ng-container
              *ngIf="committedMega.feeTicks === null && committedMega.feeDollars === null"
            >
              0 | currency:'USD':'symbol':'1.0'
            </ng-container>
          </td>
          <td class="td_cell" id="MFARMMEGA-commit-mega-settlementDate">
            <span
              class="collateral-big"
              [ngClass]="{
                'overdue-red':
                  committedMega?.status === 'OVERDUE' || committedMega?.status === 'DUEWARNING',
              }"
              >{{ committedMega?.tradeSettlementDate | date: 'MM/dd/yyyy' }}</span
            ><br />
            Commit: {{ committedMega?.committedDate | date: 'MM/dd/yyyy' }}
          </td>
          <td class="td_cell">
            <ng-container *ngIf="committedMega?.status === 'ALLOCATION_PENDING'">
              <span class="allocated allocation-pending">ALLOCATION PENDING</span>
              <span class="replace float-end" *ngIf="LDshowUpload">
                <i
                  class="fa fa-info-circle tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  title="{{ committedMega?.statusInfo }}"
                ></i>
                Info</span
              >
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'ALLOCATED'">
              <div class="collateral-status-container">
                <span class="allocated allocated-green collateral-sub-column"
                  >ALLOCATED <i class="fa fa-check-circle icon-disable allocated-green"></i
                ></span>
                <div class="collateral-sub-column">
                  <span class="replace float-end" *ngIf="LDshowUpload">
                    <i
                      class="fa fa-download download-template-icon"
                      (click)="downloadCollateralPool(committedMega)"
                    ></i>
                    <a
                      class="download-pool-info-template icon-pos"
                      (click)="downloadCollateralPool(committedMega)"
                      >Download</a
                    >
                  </span>
                  <br />
                  <ng-container
                    *ngIf="
                      LDDeallocateButton && settlementDateCheck(committedMega?.tradeSettlementDate)
                    "
                  >
                    <span>
                      <i class="fa fa-solid fa-unlock deallocation-btn"></i>
                      <a
                        class="deallocation-btn icon-pos"
                        (click)="openDeallocateModal(committedMega)"
                        >Deallocate</a
                      >
                    </span>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      LDDeallocateButton && !settlementDateCheck(committedMega?.tradeSettlementDate)
                    "
                  >
                    <span
                      class="tooltip-error"
                      data-bs-toggle="tooltip"
                      data-bs-html="true"
                      title="{{ disabledDeallocateText }}"
                    >
                      <i class="fa fa-solid fa-unlock icon-disable"></i>
                      <a class="deallocation-disabled icon-pos">Deallocate</a>
                    </span>
                  </ng-container>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'OVERDUE'">
              <span class="overdue">OVERDUE </span> &nbsp; &nbsp;
              <span class="replace float-end" *ngIf="LDshowUpload">
                <i
                  class="fa fa-info-circle tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  title="{{ committedMega?.statusInfo }}"
                ></i>
                Info</span
              ><br />
              <span class="overdue-red">{{ committedMega?.statusDate | date: 'MM/dd/yyyy' }}</span>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'DUE'">
              <div class="row">
                <div class="col-lg-6">
                  <span class="allocated">DUE </span><br />
                  <span id="MFARMMEGA-commit-mega-statusDate-due">{{
                    committedMega?.statusDate | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
                <div class="col-lg-6" *ngIf="LDshowUpload">
                  <button
                    class="button fm-primary-button float-end upload"
                    (click)="routeToPoolInfo()"
                    [disabled]="!hasCollateralUploadAccessFlag"
                    *ngIf="LDUploadPoolInfoFlag"
                  >
                    UPLOAD
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'DUEWARNING'">
              <div class="row">
                <div class="col-lg-6">
                  <span class="allocated overdue-red">DUE </span><br />
                  <span class="overdue-red" id="MFARMMEGA-commit-mega-statusDate-due">{{
                    committedMega?.statusDate | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
                <div class="col-lg-6" *ngIf="LDshowUpload">
                  <button
                    class="button fm-primary-button float-end upload"
                    (click)="routeToPoolInfo()"
                    [disabled]="!hasCollateralUploadAccessFlag"
                    *ngIf="LDUploadPoolInfoFlag"
                  >
                    UPLOAD
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'FAILED'">
              <div class="row">
                <div class="col-lg-6">
                  <span class="allocated overdue-red">FAILED </span><br />
                  <span class="overdue-red">{{
                    committedMega?.statusDate | date: 'MM/dd/yyyy'
                  }}</span>
                </div>
                <div class="col-lg-6" *ngIf="LDshowUpload">
                  <button
                    class="button fm-primary-button float-end upload"
                    (click)="routeToPoolInfo()"
                    [disabled]="!hasCollateralUploadAccessFlag"
                    *ngIf="LDUploadPoolInfoFlag"
                  >
                    UPLOAD
                  </button>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'INREVIEW'">
              <span class="in-review">IN REVIEW</span>
              <span class="replace float-end" *ngIf="LDshowUpload">
                <i
                  class="fa fa-info-circle tooltip-error"
                  data-bs-toggle="tooltip"
                  data-bs-html="true"
                  title="{{ committedMega?.statusInfo }}"
                ></i>
                Info</span
              >
              <!--&nbsp; &nbsp; <span class="in-review-cyan float-end"><i class="fa fa-refresh"></i> Replace</span> --><br />
              {{ committedMega?.statusDate | date: 'MM/dd/yyyy' }}
              <!--&nbsp; &nbsp; <span class="replace float-end"><i class="fa fa-times-circle"></i> Remove</span> -->
            </ng-container>
            <ng-container *ngIf="committedMega?.status === 'VALIDATING'">
              <span class="in-review">VALIDATING</span>
            </ng-container>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-container>
</div>
<p class="fee-warning-red">{{ disclaimerMessage }}</p>

<div class="deallocate-modal-window" *ngIf="showDeallocateModal">
  <div class="panel panel-default fadeInUpBig">
    <div class="panel-body">
      <p>You are attempting to deallocate your collateral. <br /></p>

      <h4>Do you wish to proceed?</h4>
      <br />
      <button class="button fm-tertiary-button" (click)="closeModal()">NO</button>
      <button class="button fm-primary-button" (click)="deallocateCollateral()">YES</button>
    </div>
  </div>
</div>

<ng-container *ngIf="deallocationError">
  <div class="deallocate-modal-window">
    <div class="panel panel-default fadeInUpBig">
      <div class="panel-body">
        <h4>There was an issue with your request.</h4>
        <br />
        <p>
          For assistance with this error, please contact us at
          <span class="link"
            ><a href="mailto:sto_megas@fanniemae.com">sto_megas&#64;fanniemae.com </a></span
          >
          or call 202-752-4800.
        </p>
        <br />
        <button class="button fm-primary-button" (click)="closeErrorModal()">CLOSE</button>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="processingDeallocation">
  <div class="deallocate-modal-window">
    <div class="panel panel-default fadeInUpBig">
      <div class="panel-body">
        <div><i class="fa fa-spinner fa-spin fa-3x fa-fw"></i></div>
        <h4 class="message-header">We are processing your deallocation request.</h4>
        <span>This may take a moment...</span>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="displayPagi">
  <pagination-template
    #p="paginationApi"
    [id]="config.id"
    (pageChange)="config.currentPage = $event"
  >
    <nav
      aria-label="Page navigation"
      class="settled-exchanges-pagination d-flex justify-content-end"
    >
      <ul class="pagination">
        <li class="page-item pagination-previous" [class.disabled]="p.isFirstPage()">
          <a class="page-link" (click)="p.previous()">
            <span aria-hidden="true">PREV</span>
          </a>
        </li>

        <li
          class="page-item"
          *ngFor="let page of p.pages; trackBy: trackByIdentity"
          [class.active]="p.getCurrent() === page.value"
        >
          <a
            class="page-link"
            [ngClass]="{ ellipse: page.label === '...' }"
            (click)="p.setCurrent(page.value)"
            *ngIf="p.getCurrent() !== page.value"
          >
            <span>{{ page.label }}</span>
          </a>
          <a class="page-link" *ngIf="p.getCurrent() === page.value">
            <span>{{ page.label }}</span>
          </a>
        </li>

        <li class="page-item pagination-next" [class.disabled]="p.isLastPage()">
          <a class="page-link" (click)="p.next()">
            <span aria-hidden="true">NEXT</span>
          </a>
        </li>
      </ul>
    </nav>
  </pagination-template>
</ng-container>
